import React from "react"
import "./whyfant.sass"
import IconDate from "../../images/driver/icon-date@2x.png"
import IconChart from "../../images/driver/icon-chart@2x.png"
import IconCargo from "../../images/driver/icon-cargo@2x.png"
import { defaultIntl } from "../../utils"

export default ({ intl = defaultIntl }) => {
  return (
    <div className="driver-advantage">
      <div className="container">
        <div className="text-content">
          <h2>{intl.formatMessage({ id: "driver.why.title" })}</h2>
          <p>{intl.formatMessage({ id: "driver.why.desc" })}</p>
        </div>
        <div className="columns is-centered">
          <div className="column is-one-third">
            <div className="image-box">
              <figure className="image is-96x96">
                <img src={IconDate} alt="" />
              </figure>
            </div>
            <h3>{intl.formatMessage({ id: "driver.why.a.title" })}</h3>
            <p>{intl.formatMessage({ id: "driver.why.a.desc" })}</p>
          </div>
          <div className="column is-one-third">
            <div className="image-box">
              <figure className="image is-96x96">
                <img src={IconChart} alt="" />
              </figure>
            </div>
            <h3>{intl.formatMessage({ id: "driver.why.b.title" })}</h3>
            <p>{intl.formatMessage({ id: "driver.why.b.desc" })}</p>
          </div>
          <div className="column is-one-third">
            <div className="image-box">
              <figure className="image is-96x96">
                <img src={IconCargo} alt="" />
              </figure>
            </div>
            <h3>{intl.formatMessage({ id: "driver.why.c.title" })}</h3>
            <p>{intl.formatMessage({ id: "driver.why.c.desc" })}</p>
          </div>
        </div>
      </div>
    </div>
  )
}
